import Vue from "vue";
import * as $ from "jquery";
import { Component, Prop } from "vue-property-decorator";
import { CongeDto } from "../../../../dto/GenApi.iNotPaie.Dto/CongeDto";
import ModalValidation from "./modalValidation/modalValidation";
import { UtilisateurDto } from "../../../../dto/GenApi.iNotPaie.Dto/UtilisateurDto";
import { ValideurCongesDto } from "../../../../dto/GenApi.iNotPaie.Dto/ValideurCongesDto";
import { NiveauValidationEnum } from "../../../../dto/GenApi.iNotPaie.Dto/NiveauValidationEnum";
import { UtilisateurOrigineEnum } from "../../../../dto/GenApi.iNotPaie.Dto/UtilisateurOrigineEnum";
import { ModalAlerteOptions } from "../../../modalComponents/modalAlerte/modalAlerte";
import { EventBus } from "../../../Controls/EventBus";
import EventConstants from "../../../Controls/EventConstants";
import { NotificationServiceInstance } from "../../../../shared/services/notification.service";
import { ServicesFactoryInstance } from "../../../Controls/ServicesFactory";
import { AffichagePlanningUtilisateurEnum } from "../../../../dto/GenApi.iNotPaie.Dto/AffichagePlanningUtilisateurEnum";

@Component({
	components: {
		ModalValidation: require("./modalValidation/modalValidation.vue.html"),
	}
})
export default class ValidationAbsence extends Vue {

	@Prop()
	public listeUtilisateurs: UtilisateurDto[] = [];

	@Prop()
	public idSalarie?: number;

	@Prop()
	public listeValideursConges: ValideurCongesDto[] = [];

	public niveauValidationEnum = NiveauValidationEnum;
	public utilisateurOrigineEnum = UtilisateurOrigineEnum;

	public absencePeriode: CongeDto[] = [];
	public modalValidation?: ModalValidation = undefined;

	public dataReady = true	;

	public addValidation(): void {
		if (this.modalValidation == undefined) {
			this.modalValidation = this.$refs.modalValidation as ModalValidation;
		}

		const validation: ValideurCongesDto = {
			Id: 0,
			IdSalarie: this.idSalarie ?? 0,
			Niveau: NiveauValidationEnum.Niveau_1,
			EnvoiEmail: true,
			Utilisateur: {
				Id: 0,
				Origine: UtilisateurOrigineEnum.NonDefini,
				AffichagePlanningEnum: AffichagePlanningUtilisateurEnum.Aucun,
				EstAffichagePlanningAnonymise: true
			}
		};

		this.modalValidation.init(validation);
		$("#modalValidation").modal({ backdrop: "static" });
		$("#modalValidation").modal("show");
	}

	public modifyAction(validation: ValideurCongesDto): void {
		if (this.modalValidation == undefined) {
			this.modalValidation = this.$refs.modalValidation as ModalValidation;
		}

		this.modalValidation.init({ ...validation });
		$("#modalValidation").modal({ backdrop: "static" });
		$("#modalValidation").modal("show");
	}

	public deleteAction(id: number): void {
		const modalOptions: ModalAlerteOptions = new ModalAlerteOptions({
			message: "Souhaitez-vous vraiment supprimer ce valideur d'absences ?",
			callBackYes: () => {
				this.dataReady = false;

				ServicesFactoryInstance.StatuAbsenceService.deleteValideurConges(id, () => {
					this.refreshListeValideursConges();
					NotificationServiceInstance.SendSuccess("La suppression du valideur d'absences s'est correctement déroulée !");
					this.dataReady = true;
				});
			}
		});
		EventBus.$emit(EventConstants.MODAL_ALERT, modalOptions);
	}

	public refreshListeValideursConges(): void {
		this.$emit("refreshListeValideursConges");
	}
}




// WEBPACK FOOTER //
// ./src/components/ficheSalarie/absences/validationAbsence/validationAbsence.ts